var map = {
	"./en/Layout/Drawer.json": "449a",
	"./en/Layout/Footer.json": "aeae",
	"./en/Layout/Toolbar.json": "c843",
	"./en/Layout/View.json": "6692",
	"./en/Views/Home.json": "9653"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "4999";